export const fieldStatusDetailsPanelSkeletonHeights = {
  generalFieldInfo: 140,
  recommendations: 50,
  tabbedRisk: 159,
  growthStage: 144,
  weather: 192,
  weatherChart: 244,
  status: 260,
  fieldNotes: 106,
  actionStatus: 48,
  fieldManagement: 96,
  footerActions: 48,
} as const;

export const fieldStatusDetailsPanelSectionLabelSkeletonHeight = 18;

export const fieldStatusDetailsPanelContentSkeletonsByKey = {
  recommendations: {
    key: 'recommendations',
    height: fieldStatusDetailsPanelSkeletonHeights.recommendations,
    vpadding: 'medium',
    showLabel: true,
    labelMinHeight: 22,
    labelWidth: 132,
  },
  tabbedRisk: {
    key: 'tabbedRisk',
    height: fieldStatusDetailsPanelSkeletonHeights.tabbedRisk,
    vpadding: 'no',
    showLabel: true,
    labelMinHeight: 24,
    labelWidth: 124,
  },
  growthStage: {
    key: 'growthStage',
    height: fieldStatusDetailsPanelSkeletonHeights.growthStage,
    vpadding: 'medium',
    showLabel: true,
    labelMinHeight: 22,
    labelWidth: 112,
  },
  weather: {
    key: 'weather',
    height: fieldStatusDetailsPanelSkeletonHeights.weather,
    vpadding: 'no',
    showLabel: true,
    labelMinHeight: 22,
    labelWidth: 120,
  },
  fieldNotes: {
    key: 'fieldNotes',
    height: fieldStatusDetailsPanelSkeletonHeights.fieldNotes,
    vpadding: 'medium',
    showLabel: true,
    labelMinHeight: 22,
    labelWidth: 80,
  },
  actionStatus: {
    key: 'actionStatus',
    height: fieldStatusDetailsPanelSkeletonHeights.actionStatus,
    vpadding: 'no',
    showLabel: true,
    labelMinHeight: 22,
    labelWidth: 72,
  },
  fieldManagement: {
    key: 'fieldManagement',
    height: fieldStatusDetailsPanelSkeletonHeights.fieldManagement,
    vpadding: 'medium',
    showLabel: true,
    labelMinHeight: 22,
    labelWidth: 144,
  },
} as const;

export type FieldStatusDetailsPanelContentSkeleton =
  (typeof fieldStatusDetailsPanelContentSkeletonsByKey)[keyof typeof fieldStatusDetailsPanelContentSkeletonsByKey];

export const fieldStatusDetailsPanelContentSkeletons = Object.values(
  fieldStatusDetailsPanelContentSkeletonsByKey,
);
